module.exports = __webpack_public_path__ + "static/media/PlusIcon.f3527b49.png";